import React from 'react';

class FirebaseErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Verifica se é o erro conhecido de permissão do Firebase
    if (error && 
        (error.code === 'permission-denied' || 
         (error.message && error.message.includes('Missing or insufficient permissions')))) {
      
      console.log("🔕 [ERROR BOUNDARY] Silenciando erro conhecido de Firebase:", {
        code: error.code,
        message: error.message,
        timestamp: new Date().toISOString(),
        note: "Este erro é um falso alarme - a aplicação continua funcionando"
      });
      
      // Não atualiza o state para error, permitindo que a aplicação continue
      return { hasError: false };
    }
    
    // Para outros erros, permite que sejam tratados normalmente
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log apenas erros que não são falsos alarmes do Firebase
    if (!(error && 
          (error.code === 'permission-denied' || 
           (error.message && error.message.includes('Missing or insufficient permissions'))))) {
      console.error('ErrorBoundary capturou um erro:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      // Renderiza UI de fallback apenas para erros reais
      return (
        <div style={{
          padding: '30px',
          margin: '20px',
          border: '2px solid #dc3545',
          borderRadius: '8px',
          backgroundColor: '#f8d7da',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          <h2 style={{
            color: '#721c24',
            marginBottom: '15px',
            fontSize: '24px',
            fontWeight: 'bold'
          }}>
            ⚠️ Algo deu errado
          </h2>
          <p style={{
            color: '#721c24',
            fontSize: '16px',
            marginBottom: '20px',
            lineHeight: '1.5'
          }}>
            Ocorreu um erro inesperado. Por favor, recarregue a página.
          </p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '12px 24px',
              backgroundColor: '#dc3545',
              color: '#ffffff',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '600',
              transition: 'background-color 0.2s',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#c82333'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#dc3545'}
          >
            🔄 Recarregar Página
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default FirebaseErrorBoundary;
